<template>
  <div>
    <div class="card">
      <div
        class="picture"
        :style="{ backgroundImage: `url(${member.photo_url})` }"
      >
        <img class="sr-only" :src="member.photo_url" :alt="member.name" />
      </div>
      <div class="content">
        <h3 class="cs-textstyle-item-heading">{{ member.name }}</h3>
        <p v-if="member.headline">
          {{ member.headline }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'member-card',

  props: {
    member: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  text-align: center;
  padding: 30px 20px;
  height: 100%;
  @include media-breakpoint-down(sm) {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
  }
}

.picture {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: $grey;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  overflow: hidden;
  margin-right: 10px;

  @include media-breakpoint-up(md) {
    margin: 0 auto 10px;
  }
}

h3 {
  font-weight: 700;
  margin-bottom: 0;
}

p {
  font-size: 15px;
  color: #505b64;
  margin-bottom: 0;
}

.content {
  @include media-breakpoint-down(sm) {
    max-width: 65%;
  }
}
</style>
